module.exports = __webpack_public_path__ + "static/img/4.dd58e6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/4.png
// module id = ttzs
// module chunks = 0